<form novalidate #propertySaleAttributeSectionForm="ngForm">
    <div class="property-sale-attribute-section__viewingInstructions" *ngIf="!isDwellingSubcategory">
        <tg-input-container
            class="property-sale-attribute-section__viewingInstructions-input"
            label="Viewing instructions"
            showRemainingCharacters="false"
        >
            <textarea
                tgTextInput
                ngModel
                name="viewingInstructions"
                rows="2"
                [validation]="
                    validation.propertyDescription.viewingInstructions | toValidator
                "
                placeholder="e.g. By appointment, open home date/time, etc."
                (blur)="publish()"
                [(ngModel)]="draftData.propertyDescription.viewingInstructions"
            ></textarea>
        </tg-input-container>
    </div>
    <div class="property-sale-attribute-section__amenities" *ngIf="isDwellingSubcategory">
        <tg-input-container
            class="property-sale-attribute-section__amenities-input"
            label="Amenities in this area"
            showRemainingCharacters="false"
        >
            <textarea
                tgTextInput
                ngModel
                name="amenities"
                rows="3"
                [validation]="
                    validation.propertyDescription.amenities | toValidator
                "
                placeholder="What's nearby? Shops, parks, motorway access etc."
                (blur)="publish()"
                [(ngModel)]="draftData.propertyDescription.amenities"
            ></textarea>
        </tg-input-container>
        <p class="property-sale-attribute-section__amenities-text">
            Note: Nearby schools and zoning will automatically be included based
            on the property's address
        </p>
    </div>
</form>